module.exports = __webpack_public_path__ + "img/02.3a5503e2.jpg";